import { Autocomplete, AutocompleteChangeDetails, createFilterOptions, Grid, TextField } from '@mui/material';
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import AreaModel from './models/AreaModel';
import PortModel from './models/PortModel';
import './PortSelector.scss';
import { portSelectorSelector } from './reducers/PortSelectorReducer';

interface PortSelectorProp {
    portValue?: PortModel | null,
    areaValue?: AreaModel | null,
    portLabel?: string,
    areaLabel?: string,
    isAreaRelatedToPort?: boolean,
    isAreaDisabled: boolean,
    className?: string,
    hidePort?: boolean,
    hideArea?: boolean,
    freeSolo?: boolean,
    hasPortError?: boolean,
    disable?: boolean,
    onPortChange?: (port: PortModel | null) => void
    onAreaChange?: (area: AreaModel | string | null) => void
    onAreaInputChange?: (port: string) => void
}

const PortSelector: React.FunctionComponent<PortSelectorProp> = (props) => {
    const defaultPortValue: PortModel | null = props.portValue ? props.portValue : null;
    const defaultAreaValue: AreaModel | null = props.portValue ? {
        name: props.portValue.area,
        positive: props.portValue.positive
    } as AreaModel : null;

    let dispatch = useDispatch();
    let portSelectorData = useSelector(portSelectorSelector);
    let [portValue, setPortValue] = useState<PortModel | null>(defaultPortValue);
    let [areaValue, setAreaValue] = useState<AreaModel | null>(defaultAreaValue);
    const [open, setOpen] = useState(false);
    const filterLimit = 10;

    useEffect(() => {
        let portValue = props.portValue ? props.portValue : null;
        let areaValue = props.portValue ? {
            name: props.portValue.area
        } as AreaModel : null;

        setPortValue(portValue);
        setAreaValue(areaValue);
    }, [props.portValue])

    useEffect(() => {
        let areaValue = props.areaValue == undefined ? null : props.areaValue;

        setPortValue(portValue);
        setAreaValue(areaValue);
    }, [props.areaValue])

    return <>
        {
            portSelectorData.ports &&
            <Grid container className={props.className ? props.className : ""}>
                {
                    props.hidePort != true &&
                    <Grid item xs={props.hideArea === true ? 12 : 6}>
                        <Autocomplete
                            value={portValue}
                            disabled={props.disable}
                            options={portSelectorData.ports}
                            renderInput={(params) => <TextField {...params} label={props.portLabel ? props.portLabel : "Port Name"} error={props.hasPortError} />}
                            getOptionLabel={(option: PortModel) => {
                                return option.name + " [" + option.area + "]";
                            }}
                            onChange={(event: React.SyntheticEvent, value: PortModel | null, reason: string, details?: AutocompleteChangeDetails<PortModel> | undefined) => {
                                if (props.onPortChange) {
                                    props.onPortChange(value);
                                }

                                if (value) {
                                    setPortValue(value);

                                    let areaModel = {
                                        name: (value as PortModel).area,
                                    } as AreaModel;
                                    setAreaValue(areaModel);
                                } else {
                                    setPortValue(null);

                                    setAreaValue(null);
                                }
                            }}
                            filterOptions={createFilterOptions({
                                limit: filterLimit
                            })}
                        />
                    </Grid>
                }

                {
                    !props.hideArea &&
                    <Grid item xs={props.hidePort === true ? 12 : 6}>
                        <Autocomplete
                            value={areaValue}
                            options={portSelectorData.areas}
                            freeSolo={props.freeSolo == true ? true : false}
                            open={open}
                            onOpen={() => !props.isAreaDisabled && setOpen(true)}
                            onClose={() => setOpen(false)}
                            disableClearable={props.isAreaDisabled}
                            disabled={props.isAreaDisabled}
                            getOptionLabel={(option: AreaModel) => {
                                return option.name;
                            }}
                            renderInput={(params) => <TextField {...params} label={props.areaLabel ? props.areaLabel : "Area"} disabled={props.isAreaDisabled} />}
                            onChange={(event: React.SyntheticEvent, value: AreaModel | string | null, reason: string, details?: AutocompleteChangeDetails<AreaModel> | undefined) => {
                                if (props.onAreaChange) {
                                    props.onAreaChange(value);
                                }

                                if (value as AreaModel || value as null) {
                                    setAreaValue(value as AreaModel | null);
                                }
                            }}
                            filterOptions={createFilterOptions({
                                limit: filterLimit
                            })}
                            onInputChange={(event: React.SyntheticEvent, value: string, reason: string) => {
                                if (props.onAreaInputChange) {
                                    props.onAreaInputChange(value.toUpperCase());
                                }
                            }}
                        />
                    </Grid>
                }
            </Grid>
        }
    </>;
};

export default PortSelector;